<template>
  <div class="panel" :class="aclass">
    <div class="panel-header"><slot name="header"></slot></div>
    <div class="panel-body" :key="updateindex">
      <div v-for="f in fields" class="col-xs-4 formgroup"  :key="f.id">
        <div class="input-group" v-if="f">
          <span class="input-group-addon" v-html="f.name" v-if="f.type!=6"></span>
          <span class="input-group-btn" v-if="f.type==6"><bbtn type="default" :title="f.name" @click="editVocabulary(f,$event)"></bbtn></span>
          <input v-if="f.type==0" class="form-control" v-model="values[f.id]"/>
          <input v-if="f.type==1" class="form-control" type="number" step="1" v-model="values[f.id]"/>
          <input v-if="f.type==2" class="form-control" type="number" step="0.001" v-model="values[f.id]"/>
          <toggle v-if="f.type==3" v-model="values[f.id]" :options="{ off:'Нет',offstyle:'danger',on:'Да',onstyle:'success',width:'100%' }"></toggle>
          <input v-if="f.type==4" type="date" class="form-control" v-model="values[f.id]"/>
          <input v-if="f.type==5" type="datetime-local" class="form-control"  v-model="values[f.id]"/>
          <select2 v-if="f.type==6" v-model="values[f.id]" :options="f.options" :settings="{ theme:'bootstrap',width:'100%',allowClear:true }"></select2>
        </div>
      </div>
      <div class="centered" v-if="!nobuttons"><div class="btn-group">
        <bbtn type="danger" glyph="remove" hint="Отмена" @click.prevent="cancel"></bbtn>
        <bbtn type="success" glyph="ok" hint="Принять" @click.prevent="accept"></bbtn>
      </div></div>
      <action-dialog
          action="voc_termEditor"
          :params="{ term:vocitem.term }"
          ref="dlgVocEditor"
          title="Редактор словаря"
          headerclass="primary"
          icon="cog"
          :acceptbutton="acceptvoceditor"></action-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';

export default {
  name: "inputform",
  props:['class','fields','value','nobuttons'],
  data(){
    return {
      values:[],
      prevvalue:[],
      updateindex:0,
      vocitem:{ }
    };
  },
  methods:{
    accept(){
      this.$emit("input",this.values);
      this.$emit("close",1);
    },
    cancel(){
      this.$emit("input",this.prevvalue);
      this.$emit("close",0);
    },
    editVocabulary(f){
      this.vocitem=f;
      this.$nextTick(this.$refs.dlgVocEditor.open);
    },
    acceptvoceditor(a){
      Vue.set(this.values,this.vocitem.id,a.value);
      Vue.set(this.vocitem,"options",a.options);
    }
  },
  computed:{
    aclass(){
      return this.class;
    },
  },
  created(){
    this.values=this.value??[];
    this.prevvalue=[ ...this.values];
  },
  watch:{
    value:{
      deep:true,
      immediate:true,
      handler(){
        this.values=this.value??[];
      }
    },
    values:{
      deep:true,
      handler(){
        this.$emit("input",this.values);
      }
    }
  },
  mounted(){
    this.fields.forEach(f=>{
      if ((f.type==6)&&(f.options==null))
      {
        axios.post("headless.php?actiondata=voc_getVariants",qs.stringify({ term:f.term })).then(d=>{
          Vue.set(f,"options",d.data.map(a=>{
            return {id:a.id,text:a.name};
          }));
        });
      }
    })
  }

}
</script>

<style scoped>

  div.formgroup{
    height: 2.5em;
  }

  .btn-sm{
    padding-bottom: 5px;
    padding-top: 5px;
  }

</style>